import { createStorage } from '@sg/mmkv-storage';

import { removeLegacyCsrfToken } from './legacy-csrf-token';

// ─────────────────────────────────────────────────────────────────────────────

export function getCsrfToken() {
  return AUTH_STORAGE.getString(CSRF_TOKEN_KEY);
}

export function storeCsrfToken(csrfToken: string) {
  AUTH_STORAGE.set(CSRF_TOKEN_KEY, csrfToken);
}

// ─── Constants ───────────────────────────────────────────────────────────────

const AUTH_STORAGE = createStorage({ id: 'sg.auth' });
const CSRF_TOKEN_KEY = 'csrf-token';

// ─────────────────────────────────────────────────────────────────────────────

void removeLegacyCsrfToken();
